__turbopack_context__.v({
  "buttonContainer": "qpdEDG_buttonContainer",
  "container": "qpdEDG_container",
  "desktopList": "qpdEDG_desktopList",
  "header": "qpdEDG_header",
  "mobileList": "qpdEDG_mobileList",
  "noTaxUnitsLink": "qpdEDG_noTaxUnitsLink",
  "noTaxUnitsText": "qpdEDG_noTaxUnitsText",
});
